import * as React from 'react';
import { useSelector } from 'react-redux';

import { ReviewsCount } from '../../components/Header/parts/ReviewsCount';
import { getNewbuildingInfo } from '../../selectors/newbuildingInfo';

export const ReviewsCountContainer: React.FC = () => {
  const { reviewsCount, newbuildingName, newbuildingPath, rating } = useSelector(getNewbuildingInfo);

  return (
    <ReviewsCount
      reviewsCount={reviewsCount}
      newbuildingName={newbuildingName}
      newbuildingLink={newbuildingPath}
      newbuildingRatings={rating}
    />
  );
};
